export default __webpack_public_path__ + "static/media/photo-kevin.a62ed8cd.jpeg";